"use client";

import React from "react";
import Image from "next/image";

const TypesOfExtractions: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Types of Tooth Extractions We Perform
        </h2>
        <div className="my-8 mx-auto max-w-2xl rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/illustration-of-forceps-removing-tooth-model-showing-tooth-extractions-in-astoria-queens.webp"
            alt="illustration-of-forceps-removing-tooth-model-showing-tooth-extractions-in-astoria-queens"
            width={800}
            height={600}
            className="w-full h-auto block"
            sizes="(max-width: 768px) 100vw, 672px"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Not every extraction follows the same approach. The procedure Dr.
          Khaimov recommends depends on the tooth&apos;s position, condition,
          and accessibility, and he uses two distinct methods to address each
          scenario:
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Simple Tooth Extraction
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          A simple extraction is performed when the affected tooth is visible
          above the gumline and can be loosened and lifted from the socket in
          one piece. This is the most common type of tooth removal and is
          typically completed under local anesthesia in a single visit. Simple
          extractions are frequently used for teeth with severe decay,
          trauma-related damage, or those that need to be removed before
          orthodontic treatment.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Surgical Tooth Extraction
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          A surgical extraction is required when the tooth is impacted, broken
          below the gumline, or hasn&apos;t fully erupted; most often with
          wisdom teeth. Dr. Khaimov makes a small incision to access the tooth
          and, when necessary, sections it into smaller pieces for a cleaner,
          less traumatic removal. Surgical extractions are performed under
          local anesthesia, and sedation options are available for patients
          who experience dental anxiety.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Both types of dental extractions in Astoria Queens are performed
          in-house; no specialist referrals needed.
        </p>
      </div>
    </section>
  );
};

export default TypesOfExtractions;
